import React from 'react';
import { Box, Image } from '@packages/shared';
import { useResponsiveAkamaiTemplate } from '@packages/modules/src/hooks/useResponsiveAkamaiTemplate/useResponsiveAkamaiTemplate';

export interface ImageGalleryThumbnailProps {
  imgSrc: string;
  alt: string;
}

export const ImageGalleryThumbnail = ({
  imgSrc,
  alt,
}: ImageGalleryThumbnailProps): React.ReactElement<any> => {
  const { templateName, imageDimensions } = useResponsiveAkamaiTemplate('thumbnail');

  return (
    <Box
      sx={{
        ...imageDimensions,
        position: 'relative',
        '> img': {
          maxHeight: 'auto',
          maxWidth: 'auto',
          objectFit: 'contain',
        },
      }}
    >
      <Image
        loading="lazy"
        src={`${imgSrc}?${templateName}`}
        {...imageDimensions}
        unoptimized
        alt={alt}
      />
    </Box>
  );
};
